module.exports = __webpack_public_path__ + "img/impostor-silhouete-4.2e971d49.png";